import { useState, useRef, useEffect } from "react";

const useDropdown = ({ onOpen, onClose } = {}) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef();
  const dropdownRef = useRef();
  const mounted = useRef(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (buttonRef.current && buttonRef.current.contains(e.target)) return;
      if (dropdownRef.current && dropdownRef.current.contains(e.target)) return;
      setOpen(false);
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      if (onOpen) onOpen();
    } else if (mounted.current && onClose) {
      onClose();
    }
    mounted.current = true;

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return { open, setOpen, buttonRef, dropdownRef };
};

export default useDropdown;
